import { assignWith, isUndefined } from 'lodash';

function customizer(objValue, srcValue) {
  return isUndefined(objValue) ? srcValue : objValue;
}

export function assignOnlyNewKeys(object, source) {
  assignWith(object, source, customizer);
}
